<template>
    <div class="tabs-salons panel panel-default">
        <div class="list-salons" data-infinite-scroll>
            <panel-search @search="search" placeholder="Введите наименование для поиска"
                          class="panel-search-light"></panel-search>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Салон</th>
                    <th style="text-align: center;">Привязано работников</th>
                    <th>ФИО</th>
                    <th style="text-align: center;">Действие</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="salon in salons">
                    <td>{{ salon.name }}</td>
                    <td style="text-align: center;">{{ salon.users_count }}</td>
                    <td>{{ salon.supervisor ? salon.supervisor.full_name : '' }}</td>
                    <td style="text-align: center;">
                        <a :href="`/salons/${salon.id}/edit`" class="btn btn-sm btn-delete">Редактировать</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
                scroll_height: 0,
            }
        },
        asyncComputed: {
            salons() {
                return axios
                    .get('/api/salons', {
                        params: {
                            q: this.q,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.salons = this.salons.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (! infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if(this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListSalons.vue?30093912